import React from 'react'
import { connect } from 'react-redux'
import injectSheet from 'react-jss'
import style from './style'
import { updateProjectAction } from 'actions/projectActions'
import { updateUiAction } from 'actions/uiActions'

const mapStateToProps = ({ projects, currentProjectMetadata }) => {
  const project = projects.find(p => p.id === currentProjectMetadata._id)
  return {
    title: project && project.title
  }
}

class EditProjectTitle extends React.Component {
  updateTitle = _ => {
    const { updateProjectAction, updateUiAction } = this.props
    const value = this.refs.title.value

    if (value) updateProjectAction({ title: value })
    updateUiAction({ titleChanged: true, modal: null })
  }

  render() {
    const { props: { title, close, classes }, updateTitle } = this

    return (
      <div className={classes.container}>
        <input
          className={classes.projectTitleEdit}
          type='text'
          ref='title'
          defaultValue={title || ''}
        />
        <div className={classes.buttonContainer}>
          <div className={classes.confirmButton} onClick={updateTitle}>
            Rename
          </div>
          <div className={classes.cancelButton} onClick={close}>
            Cancel
          </div>
        </div>
      </div>
    )
  }
}

export const EditProjectTitleConfig = { title: 'Rename Project' }
export default connect(mapStateToProps, { updateProjectAction, updateUiAction })(injectSheet(style)(EditProjectTitle))



// WEBPACK FOOTER //
// ./src/components/EditProjectTitle/index.js